import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { NavbarProvider } from './context/NavbarContext';
import Layout from './components/Layout/layout';
import AppRoutes from './routes/AppRoutes';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <NavbarProvider>
        <Layout>
          <AppRoutes />
        </Layout>
      </NavbarProvider>
    </BrowserRouter>
  );
}

export default App;